"use client";

import React from "react";
import AniIcon from "./primitives/AniIcon";
import "./icon-carousel.css";

/** A representative sample from the ~1,500-icon `@animaliads/animalia-icon` regular set. */
const ICON_NAMES = [
  "bezier-curve",
  "palette",
  "paint-bucket",
  "puzzle-piece",
  "gear",
  "sliders",
  "stack-simple",
  "cube",
  "code",
  "terminal-window",
  "browsers",
  "device-mobile",
  "desktop",
  "grid-four",
  "squares-four",
  "shapes",
  "cursor-click",
  "magic-wand",
  "sparkle",
  "swatches",
  "paint-brush",
  "pen-nib",
  "eyedropper",
  "frame-corners",
  "layout",
  "wheelchair",
  "eye",
  "users-three",
  "github-logo",
  "package",
  "tree-structure",
  "git-branch",
  "bounding-box",
  "selection-all",
  "flow-arrow",
];

const AnimaliaIconCarousel = () => {
  const track = [...ICON_NAMES, ...ICON_NAMES];

  return (
    <div className="ani-icon-carousel">
      <div className="ani-icon-carousel-mask">
        <div className="ani-icon-carousel-track">
          {track.map((name, index) => (
            <div className="ani-icon-carousel-cell" key={`${name}-${index}`}>
              <div className="ani-icon-carousel-glyph-row">
                <AniIcon name={name} className="ani-icon-carousel-glyph" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnimaliaIconCarousel;
